import React from 'react';
import { Star, ArrowLeft } from 'lucide-react';

const PROVIDER_URL = 'https://www.lawreviews.co.il/provider/chen-michelson';

const WIDGET_PARAMS = new URLSearchParams({
  'show-header': 'false',
  'slide-switch-interval': '4500',
  bg: 'ffffff',
  'controls-color': 'f59e0b',
  'r-text-color': '374151',
  'date-color': '6b7280',
  'main-text': '1f2937',
  logo: 'black',
});

const WIDGET_SRC = `${PROVIDER_URL}/reviews-widget?${WIDGET_PARAMS.toString()}`;

const LawReviewsWidget = ({ title = 'לקוחות ממליצים' }) => (
  <section className="py-16 md:py-24 bg-transparent" dir="rtl">
    <div className="max-w-4xl mx-auto px-4 text-center">
      <Star className="w-8 h-8 text-amber-500 mx-auto mb-2" />
      <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-8">
        {title}
      </h2>

      <iframe
        title="חוות דעת על עו״ד חן מיכלסון – LawReviews"
        src={WIDGET_SRC}
        className="block w-full h-[280px] md:h-[240px] border-0"
        loading="lazy"
        allowFullScreen
      />

      <a
        href={PROVIDER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 mt-2 text-sm md:text-base text-amber-600 hover:text-amber-700 font-semibold transition-colors"
      >
        לכל חוות הדעת על עו״ד חן מיכלסון באתר LawReviews.co.il
        <ArrowLeft className="w-4 h-4" />
      </a>
    </div>
  </section>
);

export default LawReviewsWidget;
